import { EditOutlined } from "@ant-design/icons";
import { Form, Modal } from "antd";
import { useState } from "react";
import { generatePath, useNavigate, useParams } from "react-router";
import { WishlistItem } from "../../data/types";
import EditForm from "../Pages/Wishlist/EditForm";
import Error from "../Pages/Error";
import Button from "./Button";
import DeleteWishButton from "./DeleteWishButton";
import { RoutePaths } from "../routes";
import { WishModifier } from "../../data/hooks";

interface Props {
  wish: WishlistItem;
  updateWish: WishModifier;
  deleteWish?: () => Promise<void>;
}

export default function EditWishButton({
  wish,
  updateWish,
  deleteWish,
}: Props) {
  const { wishId, wishlistId } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  if (!wishlistId || !wishId) {
    return <Error message="Wish not found" />;
  }

  const handleOk = () => {
    form.submit();
    setIsOpen(false);
  };

  const handleCancel = () => {
    form.resetFields();
    setIsOpen(false);
  };

  return (
    <>
      <Button link onClick={() => setIsOpen(true)} className="hidden! md:flex!">
        <EditOutlined />
      </Button>
      <Button
        link
        onClick={() =>
          navigate(generatePath(RoutePaths.editWish, { wishlistId, wishId }))
        }
        className="md:hidden! flex"
      >
        <EditOutlined />
      </Button>
      <Modal
        title={<div className="text-center">Edit Wish</div>}
        footer={
          <div className="flex w-full flex-row">
            <DeleteWishButton deleteWish={deleteWish} />
            <Button key="back" onClick={handleCancel} link className="grow">
              Cancel
            </Button>
            <Button
              key="submit"
              loading={false}
              onClick={handleOk}
              className="grow"
            >
              Save
            </Button>
          </div>
        }
        open={isOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={"fit-content"}
        destroyOnClose={true}
      >
        <EditForm
          wishlistId={wishlistId}
          wish={wish}
          form={form}
          isLoading={false}
          onSubmit={updateWish}
        />
      </Modal>
    </>
  );
}
